<template>
  <div class="selfBuildPlatform-page">
    <el-tabs v-model="selfBuildPlatform">
      <el-tab-pane label="平台总览" name="whole">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="wholeForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="wholeForm.way" @change="getWholeList()">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="oneMonth()">近1个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>

              <el-col :span="4">
                <el-date-picker v-model="wholeForm.eMonth" placeholder="选择日期" type="month"
                                @change="getWholeList(wholeTime = 2)" :picker-options="pickerOptions"
                                class="width-z100" size="small" format="yyyy-MM"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
          </el-form>
        </el-card>
        <div v-if="wholeForm.way == '当期网络零售额'">
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 ">
          <chart ref="chart1" :options="moneyOptions" autoresize class="width-z100 margin-t-30"></chart>
        </el-card>
          <el-row>
            <el-col :span="12">
              <el-card  class="margin-t-30 margin-l-30 text-left ">
                <div slot="header" class="index-header text-left">
                  <span class="index-header-title">自建平台排行榜</span>
                </div>
                <el-table :data="platformRankTable" stripe class="colorChang border-DEDEDE margin-b-20" height="380">
                  <el-table-column type="index" label="排名" width="100px" align="center"></el-table-column>
                  <el-table-column prop="ext" label="平台名称" align="center"></el-table-column>
                  <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                </el-table>
              </el-card>
            </el-col>
            <el-col :span="12" class="padding-l-30">
              <el-card  class="margin-t-30  text-left margin-r-30">
                <div slot="header" class="index-header text-left">
                  <span class="index-header-title">自建平台热销单品榜</span>
                </div>
              <el-table :data="goodsRankTable" stripe class="colorChang border-DEDEDE margin-b-20" height="380">
                <el-table-column prop="rank" label="排名" width="100px" align="center"></el-table-column>
                <el-table-column prop="ext" label="平台名称" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="销售额（万元）" align="center"></el-table-column>
              </el-table>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div v-if="wholeForm.way == '累计网络零售额'">
          <el-row>
            <el-col :span="14" class="padding-l-30">
              <el-card class="margin-t-30  text-left ">
              <chart ref="chart1" :options="moneyOptions" autoresize class="width-z100 margin-t-30"></chart>
              </el-card>
            </el-col>
            <el-col :span="10">
              <el-card  class="margin-t-30 margin-l-30 text-left margin-r-30">
                <div slot="header" class="index-header text-left">
                  <span class="index-header-title">自建平台排行榜</span>
                </div>
                <el-table :data="platformRankTable" stripe class="colorChang border-DEDEDE margin-b-20" height="350">
                  <el-table-column prop="rank" label="排名" width="100px" align="center"></el-table-column>
                  <el-table-column prop="ext" label="平台名称" align="center"></el-table-column>
                  <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                </el-table>
              </el-card>
            </el-col>

          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="单平台详情" name="platform">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="platformForm" label-width="92px">
            <el-form-item label="平台：">
              <el-radio v-model="platformForm.type" @change="getPlatformList" :label="type" v-for="type in industryList" :key="type.id">{{type}}</el-radio>
            </el-form-item>
            <el-form-item label="指标：">
              <el-radio-group v-model="platformForm.way" @change="getPlatformList">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3"  style="width: 125px">
                <span :class="platformTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('whole')">近13个月</span>
                <span :class="platformTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'" @click="platformTime == '2'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="platformForm.sMonth" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getPlatformList(platformTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="platformForm.eMonth" placeholder="选择日期" type="month" class="width-z100"
                                size="small" @change="getPlatformList(platformTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
          </el-form>
        </el-card>
        <div v-if="platformForm.way == '当期网络零售额'">
          <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 ">
            <chart ref="chart1" :options="options" autoresize class="width-z100 margin-t-30"></chart>
          </el-card>
          <el-row>
            <el-col :span="12">
              <el-card  class="margin-t-30 margin-l-30 text-left ">
                <div slot="header" class="index-header text-left">
                  <span class="index-header-title">网络零售额变化趋势列表</span>
                </div>
                <el-table :data="moneyTable" stripe class="colorChang border-DEDEDE" height="380">
                  <el-table-column prop="times" label="时间" align="center"></el-table-column>
                  <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                </el-table>
              </el-card>
            </el-col>
            <el-col :span="12" class="padding-l-30">
              <el-card  class="margin-t-30  text-left margin-r-30">
                <div slot="header" class="index-header text-left">
                  <span class="index-header-title">热销单品榜</span>
                </div>
                <el-table :data="goodsTable" stripe class="colorChang border-DEDEDE" height="380">
                  <el-table-column prop="rank" label="排名" width="100px" align="center"></el-table-column>
                  <el-table-column prop="absoulte_key" label="商品名称" align="center"></el-table-column>
                  <el-table-column prop="absoulte_value" label="销售额（万元）" align="center"></el-table-column>
                </el-table>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div v-if="platformForm.way == '累计网络零售额'">
          <el-row class="margin-b-20">
            <el-col :span="14" class="padding-l-30">
              <el-card class="margin-t-30  text-left ">
                <chart ref="chart1" :options="options" autoresize class="width-z100 margin-t-30"></chart>
              </el-card>
            </el-col>
            <el-col :span="10">
              <el-card  class="margin-t-30 margin-l-30 text-left margin-r-30">
                <el-table :data="moneyTable" stripe class="colorChang border-DEDEDE margin-t-20 margin-b-20" height="390">
                  <el-table-column prop="times" label="时间"  align="center"></el-table-column>
                  <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                </el-table>
              </el-card>
            </el-col>

          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>


  </div>
</template>

<script>
  export default {
    name: 'selfBuildPlatform',
    data () {
      return {
        selfBuildPlatform: 'whole',
        options: {}, //整体情况柱状图
        wholeTitle: '',//整体情况柱状图标题
        wholeList: {xTime: [], yTotalmoney: [], simple: []},//整体情况图标所需数据组装
        wholeTable: [],//整体情况表格
        wholeForm: {way: '当期网络零售额',  eMonth: ''},//整体情况筛选条件
        wholeTime: '1',
        platformForm: {type:'乡村铺子',way: '当期网络零售额',sMonth: '', eMonth: ''},
        platformPieOptions: {},//社区电商平台占比图
        platformTime: '1',
        platformList: {name: [], data: []},//社区电商平台所需数据组装
        industryList:[],
        platformRankTable:[],//自建平台排行榜
        goodsRankTable:[],//热销单品排行榜
        moneyOptions:{},//自建平台近12月网络零售额变化趋势
        moneyTable:[],//网络零售额变化趋势列表
        goodsTable:[],//热销单品榜
        orgOptions: {},
        goodsTopList: [],
        // numberList:{city:[]}
        items: [
          {type: 'danger', label: 'Top1'},
          {type: 'success', label: 'Top2'},
          {type: 'brand ', label: 'Top3'},
          {type: 'info', label: 'Top4'},
          {type: 'info', label: 'Top5'},
          {type: 'info', label: 'Top6'},
          {type: 'info', label: 'Top7'},
          {type: 'info', label: 'Top8'},
          {type: 'info', label: 'Top9'},
          {type: 'info', label: 'Top10'}
        ],
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }

    },

    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      // this.oneMonth()
      this.twelveMonth()
      this.oneMonth()
      this.getPlatformList()
      this.getWholeList()
      this.getPlatform()
    },
    methods: {
      //整体情况列表
      getWholeList () {
        // if (this.wholeForm.type == '1') {
        //   this.wholeTitle = '当期网络零售额'
        // } else {
        //   this.wholeTitle = '累计网络零售额'
        // }
        this.$http.get(this.header + '/buildPlatform/whole', {
          params: {
            index_type: this.wholeForm.way,
            times: this.wholeForm.eMonth,
          }
        }).then(res => {
          this.platformRankTable = res .data.platformRankList
          this.goodsRankTable = res .data.goodsRankList
          if (res.data.code == 0) {
            //乡村铺子
            let foodList = {xName: [], yTotalMoney: [],simple:[]}
            res.data.dataList1.forEach((y, index) => {
              foodList.xName.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: y.absoulte_key,
              }
              let yName = {
                value: y.ext,
              }
              foodList.yTotalMoney.push(yMoney)
              foodList.simple.push(yName)
            })
          //自建平台
          this.moneyOptions = {
            color: ['#c23531', '#2f4554', '#61a0a8', '#d48465', '#a4d0bc'],
            title: {
              text: '自建平台近12月网络零售额变化趋势',
              left: 'left',
              textStyle: {
                color: '#313131',
                fontSize: 18,
                fontWeight: 300,
                marginBottom: 1000
              },
            },
            tooltip: {
              trigger: 'axis',
            },
            legend: {
              // orient: 'horizontal',
              y: 'top',
              textStyle: {
                color: '#666',
                fontSize: 14
              },
              data: foodList.simple
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: foodList.xName
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '乡村铺子',
                type: 'line',
                stack: '总量',
                data: foodList.yTotalMoney
              },
            ]
          }
        } else {
            this.$alert(res.data.msg)
          }
         })
        },
      //获取平台列表
      getPlatform(){
        this.$http.get(this.header + '/buildPlatform/platformList', {
          params: {
            times: this.platformForm.eMonth,
          }
        }).then(res => {
          var a = []
          if (res.data.code == 0) {
            res.data.platformList.forEach(function (item,index) {
              a.push(item.platform)
            })
            this.industryList = a
            this.getPlatformList()
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //单平台详情
      getPlatformList () {
        if (this.platformForm.type == '1') {
          this.wholeTitle = '当期网络零售额'
        } else {
          this.wholeTitle = '累计网络零售额'
        }
        this.$http.get(this.header + '/buildPlatform/single', {
          params: {
            index_type: this.platformForm.way,
            platform:this.platformForm.type,
            sMonth: this.platformForm.sMonth,
            eMonth: this.platformForm.eMonth
          }
        }).then(res => {

          if (res.data.code == 0) {
            let moneyList = {xTime: [], yTotalMoney: []}
            res.data.list.forEach((y, index) => {
              moneyList.xTime.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              moneyList.yTotalMoney.push(yMoney)
            })
            this.moneyTable = res.data.list.reverse()
            //近13个月网络零售额走势图表
            this.options = {
              color: ['#577EC5', '#FB975B'],
              title: {//图表标题
                text: this.platformForm.type + this.platformForm.way + '变化趋势',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 16,
                  fontWeight: 300,
                  marginBottom: 10000
                },
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: function (e) {
                  return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                }
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line']},
                  restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              legend: {//图表说明  horizontal竖着显示vertical横显示
                orient: 'horizontal',
                y: 'bottom',
                // x: 'left',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: ['当期网络零售额']
              },
              xAxis: {
                type: 'category',
                data: moneyList.xTime,
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                }
              },
              yAxis: [
                {
                  type: 'value',
                  name: '万元',
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  splitNumber: 5,
                }],
              series: [{
                name: '当期网络零售额',
                type: 'bar',
                barCategoryGap: '60%',
                barWidth: 20,
                itemStyle: {
                  emphasis: {
                    color: '#87B2FF'
                  }
                },
                data: moneyList.yTotalMoney,
                smooth: true
              }]
            }

          } else {
            this.$alert(res.data.msg)
          }

        })
      },

      //选择近13个月
      twelveMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 15; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if(day > 14){
          this.platformTime = '1'
          this.platformForm.sMonth = dataArr[13]
          this.platformForm.eMonth = dataArr[1]
        }else{
          this.platformTime = '1'
          this.platformForm.sMonth = dataArr[14]
          this.platformForm.eMonth = dataArr[2]
        }
        this.getPlatformList()
      },
      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
      //选择近1个月
      oneMonth (val) {
        var dataArr = []
        var data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if(day > 14){
          this.wholeTime = '1'
          this.wholeForm.eMonth = dataArr[1]
        }else{
          this.wholeTime = '1'
          this.wholeForm.eMonth = dataArr[2]
        }
        this.wholeTime = '1'
        this.getWholeList()
      },
    }
  }
</script>

<style>


  .selfBuildPlatform-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
  }

  .selfBuildPlatform-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .selfBuildPlatform-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .selfBuildPlatform-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .selfBuildPlatform-page .el-form-item {
    margin-bottom: 0;
  }

  .selfBuildPlatform-page .selfBuildPlatform-header {
    line-height: 40px;
    background-color: #323740;
    color: white;
  }

  .selfBuildPlatform-page .selfBuildPlatform-header span {
    background-color: #3865A5;
    line-height: 40px;
    width: 180px;
    height: 45px;
    display: block;
    text-align: center;
  }

  .selfBuildPlatform-page .selfBuildPlatform-bottom .el-tag {
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    border-radius: 20px;
  }

  .selfBuildPlatform-page .selfBuildPlatform-bottom .selfBuildPlatform-bottom-three {
    height: 608px;
  }

  .selfBuildPlatform-page .el-form-item {
    margin-bottom: 0;
  }


  .selfBuildPlatform-page .index-header-title {
    /*font-weight: bold;*/
    margin-bottom: 10px;
    margin-top: 10px;
    color: #313131;
    font-size: 18px;
  }
  .selfBuildPlatform-page .el-card__body{
    padding: 5px 20px;
  }

  .el-date-picker__header--bordered {
    border-bottom: solid 1px #D0D6DF;
  }

</style>



// WEBPACK FOOTER //
// src/components/characteristic/selfBuildPlatform.vue